import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";
import Reveal from "./Reveal";
import { IMAGES } from "./data";

export default function BeforeAfter() {
  const ref = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(50);

  const setFromClientX = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    setPos(Math.min(96, Math.max(4, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <section id="before-after" data-testid="before-after-section" className="bg-white py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-sapphire">Proof, not promises</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Drag to see the swaclean difference
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base">
            Real transformation, one deep clean apart. Slide the handle to compare a space before and after our crew
            steps in.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            ref={ref}
            data-testid="before-after-slider"
            className="spotlight-frame relative mx-auto mt-12 aspect-[16/10] max-w-4xl cursor-ew-resize touch-none select-none overflow-hidden rounded-[2rem] sm:aspect-[16/8]"
            onPointerDown={(e) => {
              dragging.current = true;
              e.currentTarget.setPointerCapture(e.pointerId);
              setFromClientX(e.clientX);
            }}
            onPointerMove={(e) => {
              if (dragging.current) setFromClientX(e.clientX);
            }}
            onPointerUp={() => {
              dragging.current = false;
            }}
            onPointerCancel={() => {
              dragging.current = false;
            }}
          >
            <img
              src={IMAGES.after}
              alt="Spotless room after swaclean deep cleaning"
              draggable={false}
              className="absolute inset-0 h-full w-full object-cover"
            />
            <img
              src={IMAGES.before}
              alt="Room before swaclean deep cleaning"
              draggable={false}
              className="absolute inset-0 h-full w-full object-cover"
              style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
            />

            <span className="absolute left-4 top-4 rounded-full bg-slate-900/70 px-3 py-1 text-xs font-bold uppercase tracking-[0.2em] text-white backdrop-blur-sm">
              Before
            </span>
            <span className="absolute right-4 top-4 rounded-full bg-sapphire px-3 py-1 text-xs font-bold uppercase tracking-[0.2em] text-white">
              After
            </span>

            <div
              data-testid="before-after-slider-handle"
              className="absolute inset-y-0 z-10"
              style={{ left: `${pos}%` }}
            >
              <div className="absolute inset-y-0 -left-px w-0.5 bg-white shadow-[0_0_12px_rgba(0,0,0,0.4)]" />
              <span className="absolute top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-4 border-white bg-sapphire text-white shadow-xl">
                <ChevronsLeftRight className="h-5 w-5" />
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
